module.exports = __webpack_public_path__ + "img/icon-1.bd09d000.svg";